export const ATTACHMENT_TYPES = {
  photos: {
    label: "Photos"
  }
};



// WEBPACK FOOTER //
// ./app/modules/MistakeShipments/constants.js